import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class TagIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 32 32"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<g style={{transform: "rotate(-135deg)", transformOrigin: "center"}}>
					<path
						d="M 11.062957,33.550565 -1.580844,20.817873 14.811669,4.5398015 27.309489,4.4971237 27.500458,17.22782 Z M 0.99039371,20.82244 11.100213,30.933167 25.668439,16.466647 25.487512,6.3063807 l -9.92797,0.048623 z"
						style={{
							stroke: "#000000",
							strokeWidth: 1,
							strokeOpacity: 1
						}}/>
					<circle
						cx="22.963629"
						cy="8.8846788"
						r="1.3613882"
						style={{
							stroke: "#000000",
							strokeWidth: 1,
							strokeOpacity: 1,
							fill: "#000000"
						}}/>
					<path
						d="m 20.513607,6.3460246 c 2.712622,-0.012451 4.938089,-0.016547 4.945482,-0.0091 0.0074,0.00744 0.0537,2.2857024 0.102909,5.0627936 l 0.08947,5.049258 -7.28274,7.231896 -7.282739,7.231896 -1.4166058,-1.426565 C 8.8902458,28.701591 6.6243702,26.433126 4.634163,24.445105 L 1.0155527,20.830574 8.2985616,13.599618 15.58157,6.3686611 Z m 1.229912,1.9170743 c -0.384381,0.7218077 -0.02419,1.6206352 0.766467,1.9126801 0.551741,0.203796 1.214314,4.36e-4 1.557119,-0.4779194 0.270477,-0.3774278 0.339662,-0.8382093 0.190463,-1.2685097 -0.139126,-0.4012491 -0.530111,-0.7656727 -0.937074,-0.873416 -0.172484,-0.045664 -0.478621,-0.051637 -0.656589,-0.012808 -0.366311,0.079919 -0.731787,0.3658138 -0.920386,0.7199731 z"
						style={{
							fill: this.props.color,
							fillOpacity: 0.5,
							stroke: "#000000",
							strokeWidth: 0.5,
							strokeOpacity: 1
						}}/>
				</g>
			</svg>
		);
	}
}